import isArray from 'lodash-es/isArray'

import { RoleEnum } from '/@/enums/userEnum'

/**
 * Check user role is any one of them.
 * @param value
 * @param role
 */
export function checkRole(
  role: RoleEnum,
  value?: RoleEnum | RoleEnum[] | string | string[],
): boolean {
  if (!value) return true

  if (!isArray(value)) {
    return value === role
  }
  // It means multiple role can do that.
  return value.includes(role)
}
